import { DtoICollection, ICardCollection } from '../../../models/collection';
import { processCardsDtoUnified, convertCardsToDtoCards } from './cards-dto-processor';

export function processCollectionDtoResponse(rawResponse: DtoICollection[]): ICardCollection[] {
  // Handle null/undefined response
  if (!rawResponse || !Array.isArray(rawResponse)) {
    console.warn('[CollectionsDtoProcessor] Received invalid response:', rawResponse);
    return [];
  }

  // Filter out null/undefined collections before processing
  return rawResponse
    .filter(collection => collection != null)
    .map(({
      collection_id,
      share_id,
      collection_preview_link_app,
      collection_poster_link_app,
      collection_preview_link_web,
      collection_poster_link_web,
      author_id,
      user_id,
      owner_id,
      title,
      description,
      collection_models,
      created,
      updated,
      is_shared
    }) => {
      const collectionCards = collection_models
        ? processCardsDtoUnified(collection_models, { parentCollectionId: collection_id })
        : [];
      const firstCard = collectionCards[0];

      return {
        collectionId: collection_id,
        collectionSharingId: share_id,
        collectionContentMobile: collection_preview_link_app || firstCard?.cardContentMobile || '',
        collectionPosterMobile: collection_poster_link_app || firstCard?.cardPosterMobile || '',
        collectionContentWeb: collection_preview_link_web || firstCard?.cardContentWeb || '',
        collectionPosterWeb: collection_poster_link_web || firstCard?.cardPosterWeb || '',
        accessType: 'Private',
        collectionAuthor:  author_id || user_id || owner_id,
        collectionTitle: title,
        collectionDescription: description,
        created,
        updated,
        isShared: is_shared,
        collectionCards
      };
    });
}

export function processDraftCollectionDtoResponse(rawResponse: DtoICollection[]): ICardCollection[] {
  const collections = processCollectionDtoResponse(rawResponse);
  console.log('processDraftCollectionDtoResponse Processed: ', collections);
  return collections;
}

export function convertCollectionToDtoCollection(collection: ICardCollection): DtoICollection {
  return {
    collection_id: collection.collectionId,
    share_id: collection.collectionSharingId,
    collection_preview_link_app: collection.collectionContentMobile,
    collection_poster_link_app: collection.collectionPosterMobile,
    collection_poster_link_web: collection.collectionPosterMobile,
    collection_preview_link_web: collection.collectionContentMobile,
    author_id: collection.collectionAuthor,
    user_id: collection.collectionAuthor,
    title: collection.collectionTitle,
    description: collection.collectionDescription,
    collection_models: collection.collectionCards ? convertCardsToDtoCards(collection.collectionCards) : [],
    type: 'collection',
    status: 'private',
    created: collection.created,
    updated: collection.updated,
    is_shared: collection.isShared
  };
}
